export enum TipoCompetencia {
    Comparador = 1,
    CTT = 2,
}